/**
 * Creates a duplicate-free version of an array,
 * it accepts iteratee which is invoked for each element in array to generate
 * the criterion by which uniqueness is computed.
 *
 * @template T
 * @param {Array<T>} array
 * @param {(string | Function)} predicate
 * @return {*}  {Array<T>}
 *
 * @example
 * uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // returns [2.1, 1.2]
 *
 * @example
 * uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * returns [{ 'x': 1 }, { 'x': 2 }]
 *
 */
export var uniqBy = function (array, predicate) {
    var set = new Set();
    var predicateFunction = typeof predicate === 'string'
        ? function (item) { return item[predicate]; }
        : function (item) { return predicate(item); };
    return array.reduce(function (resultArray, item) {
        if (!set.has(predicateFunction(item))) {
            set.add(predicateFunction(item));
            resultArray.push(item);
        }
        return resultArray;
    }, []);
};
//# sourceMappingURL=uniqBy.js.map